import { Controller } from "@hotwired/stimulus"

// Phase 2.5 Tier 3 — Capital Request detail page. Manages the reject /
// withdraw / convert modals (centered, backdrop-dismissable, panel-
// stop-propagation per CLAUDE.md).
export default class extends Controller {
  static targets = ["rejectModal", "withdrawModal", "convertModal"]
  static values = { id: Number }

  showRejectModal()   { this._show("rejectModal") }
  hideRejectModal()   { this._hide("rejectModal") }
  showWithdrawModal() { this._show("withdrawModal") }
  hideWithdrawModal() { this._hide("withdrawModal") }
  showConvertModal()  { this._show("convertModal") }
  hideConvertModal()  { this._hide("convertModal") }

  stopPropagation(event) {
    event.stopPropagation()
  }

  _show(targetName) {
    const t = this[`${targetName}Target`]
    if (!t) return
    t.classList.remove("hidden")
  }

  _hide(targetName) {
    const t = this[`${targetName}Target`]
    if (!t) return
    t.classList.add("hidden")
  }
}
